import styled from "styled-components";
import ReleaseTable from "./ReleaseTable";
import { Button } from "shared/components/Button";
import useReleaseView from "features/homework/hooks/useReleaseView";
import Modal from "shared/components/Modal";
import LoadingSpinner from "shared/components/Spinner";

const ReleaseView = () => {
    const {branchList, selectedBranchList, folderList, selectedItems, onSelectBranchClickHandler, onSelectReportClickHandler,
        effectiveDate, onEffectiveDateChangeHandler,
        onReportReleseClickHandler,
        isOpenDateErrorModal, onDateErrorModalConfirmClickHandler,
        isOpenNullModal, onNullModalConfirmClickHandler,
        isOpenReleaseFailedModal, onFailedModalConfirmClickHandler,
        isOpenReleaseSucceedModal, onSucceedModalConfirmClickHandler,
        isOpenWarningModal, onReportReleaseCancelClickHandelr, onReportReleaseConfirmhandler,
        setting, onOpenSettingModalClickHandler, onDeleteSettingClickHandler,
        onOpenScheduleModalClickHandler, onOpenDateScheduleModalClickHandler,
        isLoading, releaseFailureMessage, pendingReleaseCount, onRetryReleaseClickHandler
    } = useReleaseView();
    return(
        <Container>
            <PageHeader>
                <PageTitle>과제 배포</PageTitle>
                <PageDesc>지점과 과제를 선택한 뒤 배포하세요.</PageDesc>
            </PageHeader>
            {isLoading && (
                <Modal isOpen={true} title="처리중입니다" content={<LoadingSpinner width={80} />} onClose={() => {}} />
            )}
            <Modal isOpen={isOpenWarningModal} title="WARNING" content="배포를 하시면 중복된 과제는 덮어씌워집니다" onConfirm={onReportReleaseConfirmhandler} onClose={onReportReleaseCancelClickHandelr}/>
            <Modal isOpen={isOpenDateErrorModal} title="ERROR" content="종료일이 시작일보다 빠를 수 없습니다" onClose={onDateErrorModalConfirmClickHandler}/>
            <Modal isOpen={isOpenNullModal} title="ERROR" content="배포할 과제를 선택 해주세요" onClose={onNullModalConfirmClickHandler}/>
            <Modal isOpen={isOpenReleaseSucceedModal} title="SUCCESS" content="과제 배포에 성공하였습니다" onClose={onSucceedModalConfirmClickHandler}/>
            <Modal isOpen={isOpenReleaseFailedModal} title="ERROR" content={releaseFailureMessage} onClose={onFailedModalConfirmClickHandler}/>
            {pendingReleaseCount > 0 && (
                <div role="status">
                    완료되지 않은 배포 {pendingReleaseCount}건이 있습니다. 기존 선택과 일정으로 이어서 처리할 수 있습니다.
                    <button type="button" disabled={isLoading} onClick={onRetryReleaseClickHandler}>미완료 배포 재시도</button>
                </div>
            )}
            <ReleaseTable 
                branchList={branchList}
                selectedBranchList={selectedBranchList}
                folderList={folderList}
                selectedItems={selectedItems}
                onSelectBranchClickHandler={onSelectBranchClickHandler}
                onSelectReportClickHandler={onSelectReportClickHandler}
                effectiveDate={effectiveDate}
                onEffectiveDateChangeHandler={onEffectiveDateChangeHandler}
                setting={setting}
                onOpenSettingModalClickHandler={onOpenSettingModalClickHandler}
                onDeleteSettingClickHandler={onDeleteSettingClickHandler}
                onOpenScheduleModalClickHandler={onOpenScheduleModalClickHandler}
                onOpenDateScheduleModalClickHandler={onOpenDateScheduleModalClickHandler}
                showEndDate={true}
                branchHeader="지점"
                showBranchColumn={true}
                showSettingSection={false}
                showScheduleButtons={false}
            />
            <ButtonWrap><Button name="배포" onButtonClick={onReportReleseClickHandler}/></ButtonWrap> 
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    flex-grow: 1;
    min-height: 0;
    padding: 24px 28px;
    overflow: auto;
`

const PageHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`

const PageTitle = styled.h2`
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #0F172A;
    letter-spacing: -0.02em;
`

const PageDesc = styled.p`
    margin: 0;
    font-size: 13px;
    color: #64748B;
`

const ButtonWrap = styled.div`
    display: flex;
    justify-content: end;
`


export default ReleaseView;